import React from 'react';
import { Icon, Tooltip } from 'antd';

import anon from '../img/anon.png';
import Spacer from './Spacer';
import { specialties, panelIcons, panelTexts } from '../data';

import * as util from '../util';

const PeopleList = ({ p, verbose }) => {
  return (p.people || []).map((person, i) => {
    const { fn, ln, cert, bio, image, prof, specialty, panelStatus } = person;
    let fullName = `${fn} ${ln}`;
    if (cert) fullName = fullName.trim() + ', ' + cert;

    let profIcon = null;
    if (prof) {
      let profLink = prof;
      if (!profLink.includes('http')) profLink = 'https://' + profLink;
      profIcon = (
        <a target="_blank" rel="noopener noreferrer" href={profLink}>
          <Icon type="link" />
        </a>
      );
    }

    let panelIcon = null;
    if (panelStatus) {
      panelIcon = (
        <Tooltip title={panelTexts[panelStatus]}>
          <Icon
            type={panelIcons[panelStatus]}
            style={{ color: '#808080', cursor: 'auto', fontSize: '15px' }}
          />
        </Tooltip>
      );
    }
    let personLine = (
      <span>
        {fullName + ' '}
        {panelIcon} {profIcon}
      </span>
    );

    if (!verbose) return <p key={i}>{personLine}</p>;

    let specMap = util.objify(specialties, 'value', 'label');
    console.log('IMAGE');
    console.log(image);

    return [
      <div className="PersonRow" key={i}>
        {image && (
          <div
            className="img"
            style={{ backgroundImage: `url(${image || anon})` }}
          />
        )}
        <div className="col " style={{ flex: 1 }}>
          <h5>{personLine}</h5>
          {specialty && (
            <p>
              <small>{specMap[specialty]}</small>
            </p>
          )}
          {bio && <p>{bio}</p>}
        </div>
      </div>,
      <Spacer size={i === p.people.length - 1 ? 'none' : 'medium'} />,
    ];
  });
};

export default PeopleList;
